import { Button, DialogActions } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import PropTypes from 'prop-types';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function BookmarkDialogConfirm({
    isOpen,
    msgConfirm,
    className = '',
    saveAndCancelCallBack,
    cancelCallBack,
    closeCallBack,
}) {
    // Re-render when the translation dictionary loads/updates
    useTranslationSubscription();

    return (
        <Dialog
            open={isOpen}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className={`wrapDialog ${className}`}
        >
            <DialogContent>
                <div className="confirmPlease">{msgConfirm}</div>
            </DialogContent>
            <DialogActions className="confirm-dialog-action">
                {saveAndCancelCallBack && (
                    <Button
                        onClick={saveAndCancelCallBack}
                        variant="contained"
                        style={{backgroundColor: '#CC4733', color: 'white'}}
                        size='small'
                    >
                        {trI18n('COMBTN002')}
                    </Button>
                )}

                {closeCallBack && (
                    <Button
                        variant="contained"
                        className="btn-light btn-hg32"
                        size='small'
                        onClick={closeCallBack}
                    >
                        {trI18n('COMBTN007')}
                    </Button>
                )}

                {cancelCallBack && (
                    <Button
                        variant="contained"
                        className="btn-light btn-hg32"
                        size='small'
                        onClick={cancelCallBack}
                    >
                        {trI18n('COMBTN001')}
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    );
}


BookmarkDialogConfirm.propTypes = {
    isOpen: PropTypes.any,
    msgConfirm: PropTypes.any,
    className: PropTypes.any,
    saveAndCancelCallBack: PropTypes.any,
    cancelCallBack: PropTypes.any,
    closeCallBack: PropTypes.any,
};